import React, { useContext } from "react";
import { RicosContext } from "./../../../ricos-context/index.js";
import { KEYS_CHARCODE } from "./../../../editor-common/index.js";
import { alignmentsMap, defaultAlignments } from "../../buttons/NodeAlignmentButton/consts.js";
import { ListItemSection, ListItemSelect, ListItemToggle } from "../ListItem/index.js";
import DropdownModal from "./DropdownModal.js";
const AlignmentPanel = ({
  getSelectedAlignment,
  onClick,
  options,
  getSelectedTextWrap,
  onTextWrapToggle,
  isTextWrapDisabled
}) => {
  const { t, jsdomMode } = useContext(RicosContext) || {};
  const selectedAlignment = getSelectedAlignment();
  const disableTextWrap = isTextWrapDisabled?.() || selectedAlignment === "CENTER";
  const OPTIONS = options ? options.map((option) => alignmentsMap[option]) : defaultAlignments;
  const onKeyDown = (e, commandKey) => {
    if (e.keyCode === KEYS_CHARCODE.ENTER) {
      onClick(commandKey);
      e.stopPropagation();
    }
  };
  const alignmentOptions = OPTIONS.filter(
    (option) => (
      // @ts-expect-error $TSFixMe
      ["LEFT", "RIGHT", "CENTER"].includes(option.commandKey)
    )
  );
  const textWrapOption = OPTIONS.find(
    (option) => option.commandKey === "TEXT_WRAP"
  );
  const AlignmentDropdownOptions = alignmentOptions.map(
    // @ts-expect-error $TSFixMe
    ({ dataHook, icon: Icon, text, commandKey, tooltip }) => /* @__PURE__ */ React.createElement(
      ListItemSelect,
      {
        key: commandKey,
        dataHook,
        prefix: /* @__PURE__ */ React.createElement(Icon, null),
        title: t(text),
        selected: commandKey === selectedAlignment,
        tooltip: t(tooltip),
        onKeyDown: (e) => {
          onKeyDown(e, commandKey);
        },
        onClick: () => onClick(commandKey)
      }
    )
  );
  const getTextwrapDropdownOption = () => /* @__PURE__ */ React.createElement(
    ListItemToggle,
    {
      key: textWrapOption.commandKey,
      dataHook: textWrapOption.dataHook,
      onChange: onTextWrapToggle ?? (() => {
      }),
      title: t(textWrapOption.text),
      selected: disableTextWrap ? false : getSelectedTextWrap?.() ?? true,
      infoContent: disableTextWrap ? t(
        selectedAlignment === "CENTER" ? textWrapOption.infoIconTextAlignedCenter : textWrapOption.infoIconTextUnsupportedContainer
      ) : void 0,
      disabled: disableTextWrap
    }
  );
  const separator = /* @__PURE__ */ React.createElement(ListItemSection, { type: "divider" });
  const DropdownOptions = textWrapOption ? [...AlignmentDropdownOptions, separator, getTextwrapDropdownOption()] : [...AlignmentDropdownOptions];
  return /* @__PURE__ */ React.createElement(DropdownModal, { options: DropdownOptions, jsdomMode });
};
var AlignmentPanel_default = AlignmentPanel;
export {
  AlignmentPanel_default as default
};
//# sourceMappingURL=AlignmentPanel.js.map
